import { ContractService } from 'src/app/services/contracts/contract.service';
import { ConfigService } from "./../../../services/config.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Component, ElementRef, HostListener, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ContactService } from "src/app/services/contact.service";
import { GridConnectionService } from "src/app/services/grid-connection.service";
import {
  DxButtonModule,
  DxDataGridModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTagBoxModule,
  DxToastModule,
  DxTextBoxModule,
  DxValidatorModule,
  DxValidationGroupModule,
  DxValidationGroupComponent,
} from "devextreme-angular";
import { AppGlobals } from "src/app/app.globals";
import { DeletePopupComponent } from "src/app/components/delete-popup/delete-popup.component";
import { environment } from "src/environments/environment";
import { FeatureFlags } from "src/app/interfaces/enums/feature-flag";
import { Observable, of, Subject, takeUntil } from "rxjs";
import { HasChanges } from "src/app/services/guards/unsaved-changes.guard";
import { custom } from 'devextreme/ui/dialog';
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";
import { GpdPillComponent } from "src/app/components/gpd-pill/gpd-pill.component";
import { SvgIconComponent } from "src/app/components/svg-icon/svg-icon.component";
import { FormFooterComponent } from "src/app/components/form-footer/form-footer.component";
import { ContractsPillComponent } from "src/app/components/contracts-pill/contracts-pill.component";
import { GetCompanyDetailsResultModel, GetContactProjectsResultModel } from "src/app/interfaces/entities/contact";
import { ActivityLogService } from "src/app/services/activity-log.service";
import { ActivityEntity, ActivitySection } from "src/app/constants/activity-log";
import { ContactAddProjectModalComponent } from "src/app/pages/contacts/contact-add-project-modal/contact-add-project-modal.component";
import { ValidationToastComponent } from "src/app/components/validation-toast/validation-toast.component";

import { SearchableDropdownDirective } from '../../../directives/searchable-dropdown.directive';
@Component({
    selector: "app-contacts-company-details.page",
    imports: [
        CommonModule,
        DxDataGridModule,
        DxButtonModule,
        DxPopupModule,
        DxToastModule,
        DeletePopupComponent,
        DxTagBoxModule,
        DxSelectBoxModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxValidationGroupModule,
        GpdButtonComponent,
        GpdPillComponent,
        SvgIconComponent,
        FormFooterComponent,
        ContractsPillComponent,
        ContactAddProjectModalComponent,
        ValidationToastComponent,
        SearchableDropdownDirective
    ],
    templateUrl: "./contacts-company-details.page.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./contacts-company-details.page.css"]
})
export class ContactsCompanyDetailsPageComponent implements OnInit, HasChanges {

  type: any = "";
  message: any = "";
  toastVisible: boolean = false;

  addProjectModalVisible: boolean = false;

  @ViewChild("popupPersonGrid") popupPersonGrid;
  @ViewChild("companyValidationGroup") companyValidationGroup: DxValidationGroupComponent;
  @ViewChild("validationToast") validationToast: ValidationToastComponent;
  @ViewChild("projectsListEl") projectsListEl?: ElementRef<HTMLElement>;
  @ViewChild("contractsListEl") contractsListEl?: ElementRef<HTMLElement>;

  // Search box only makes sense once the list actually needs scrolling - measured once
  // against the full (unfiltered) list right after it loads, not re-measured while typing,
  // so the box doesn't vanish mid-search as filtering shrinks the visible rows.
  projectsListScrollable = false;
  contractsListScrollable = false;

  private updateProjectsScrollable(): void {
    setTimeout(() => {
      const el = this.projectsListEl?.nativeElement;
      this.projectsListScrollable = !!el && el.scrollHeight > el.clientHeight;
    });
  }

  private updateContractsScrollable(): void {
    setTimeout(() => {
      const el = this.contractsListEl?.nativeElement;
      this.contractsListScrollable = !!el && el.scrollHeight > el.clientHeight;
    });
  }

  currentCompanyId: any;

  company: any;
  companyCheckClone: any;
  companyPersons: any;
  persons: any;
  contactTags: any;

  personPopupVisible: any;
  personEditMode: boolean = false;

  companyCopy: any;
  editMode: boolean = true;

  // Same unsaved-changes guard as the contract form (see hasChangesGuard): baseline
  // snapshot taken once the company has loaded, compared against on every navigation
  // attempt away from this page.
  hasChanges: boolean = false;
  isSavingChanges: boolean = false;
  private initialCompany: any;

  deletePopupVisible: boolean = false;

  relatedProjects: any;
  private projectsStatusById: Map<number, string> = new Map();
  private projectsFromDetails: Array<{ id: number; nr: string; name: string; status: string | null }> = [];

  countries: any = [
    { name: "Deutschland" },
    { name: "Österreich" },
    { name: "Schweiz" },
    { name: "Niederlande" },
    { name: "Belgien" },
    { name: "Luxemburg" },
    { name: "Frankreich" },
  ];

  countriesByLanguageList: any = [];
  statesByLanguageList: any = [];
  isCtrlPressed: boolean;
  contractsEnabled: boolean = false;
  relatedContracts: any;

  $unsubscribe = new Subject<any>;
  featureFlagsLoaded: boolean = false

  private syncRelatedProjectStatuses(): void {
    if (!Array.isArray(this.relatedProjects)) return;
    this.relatedProjects.forEach((item: any) => {
      const project = item?.project;
      if (!project) return;
      const projectId = Number(project.projectId ?? project.id ?? item.projectId ?? item.id);
      if (!project.status && projectId) {
        project.status = this.projectsStatusById.get(projectId) ?? null;
      }
      if (!project.status) {
        const nr = project.nr ?? item.nr ?? "";
        const name = project.projectName ?? project.name ?? item.projectName ?? item.displayName ?? item.name ?? "";
        const matched = this.projectsFromDetails.find((p) => p.nr === nr && p.name === name);
        project.status = matched?.status ?? null;
      }
    });
  }

  constructor(
    private contactService: ContactService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private configService: ConfigService,
    private gridConnectionService: GridConnectionService,
    private appGlobals: AppGlobals,
    private contractService: ContractService,
    private activityLog: ActivityLogService
  ) { }

  ngOnInit(): void {

     this.appGlobals.$features
        .pipe(takeUntil(this.$unsubscribe))
        .subscribe(() => {
          this.contractsEnabled = AppGlobals.UserCan(FeatureFlags.Contracts);
          this.featureFlagsLoaded = true;

          this.getPageData();
          this.getCountriesByLanguage();
        });
  }

  async getPageData() {
    this.contactTags = await this.configService.loadContactTags();
    this.currentCompanyId = this.activatedRoute.snapshot.url[1].path;

    this.contactService
      .getCompanyDetails({ CompanyId: this.currentCompanyId })
      .then(
        (result: GetCompanyDetailsResultModel) => {
          if (result.hasError === true)
            AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.company = result.companyDetailItem.companyDetails;
            this.activityLog.logView({
              Section: ActivitySection.CONTACTS_COMPANY,
              EntityType: ActivityEntity.COMPANY,
              EntityId: Number(this.currentCompanyId),
              EntityLabel: this.company?.name,
            });
            this.companyCheckClone = result.companyDetailItem.companyDetails;
            this.initialCompany = JSON.parse(JSON.stringify(this.company));
            this.companyPersons = result.companyDetailItem.persons;
            const projects = result.companyDetailItem.projects ?? [];
            this.projectsStatusById = new Map(
              projects.map((p: any) => [Number(p.id), p.status])
            );
            this.projectsFromDetails = projects.map((p: any) => ({
              id: Number(p.id),
              nr: p.nr ?? "",
              name: p.name ?? "",
              status: p.status ?? null,
            }));
            this.syncRelatedProjectStatuses();
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );

    this.loadRelatedProjects();

    let payload = {
      contactId: Number(this.currentCompanyId),
      contactType: "company",
    };

      if(this.contractsEnabled) {
        this.contactService.getRelatedContracts({ ContactProjectRequestItem: payload }).then(result => {
          if (result.hasError === true) {
            AppGlobals.ShowErrorMessage(result.feedback);
          } 
          else {
            this.relatedContracts = result.contracts;
            this.updateContractsScrollable();
          }
        });
      }
  }

  // Also called after "Add to Project" links a new project, so the grid reflects it
  // without a full page reload.
  private loadRelatedProjects(): void {
    const payload = {
      contactId: Number(this.currentCompanyId),
      contactType: "company",
    };

    this.contactService
      .getContactProjects({ ContactProjectRequestItem: payload })
      .then((result: GetContactProjectsResultModel) => {
        result.contactProjectItems.forEach((item) => {
          const project = item.project ?? {};
          project.projectId = project.projectId ?? project.id ?? item.projectId ?? item.id ?? null;
          project.siteId = project.siteId ?? item.siteId ?? null;
          project.nr = project.nr ?? item.nr ?? "";
          project.projectName =
            project.projectName ??
            project.displayName ??
            project.name ??
            project.title ??
            item.projectName ??
            item.displayName ??
            item.name ??
            (project.projectId ? `${project.projectId}` : "");
          project.status =
            item.status ??
            project.status ??
            project.projectStatus ??
            this.projectsStatusById.get(Number(project.projectId)) ??
            null;
          item.project = project;

          item.routingInfo?.forEach((route) => {
            if (route.description === 'Cost Partner') {
              route.description = $localize`:@@costPartner:Service Provider`;
            }
            if (route.description === 'Cost Debitor') {
              route.description = $localize`:@@costDebitor:Debtor`;
            }
          });
        });
        this.relatedProjects = result.contactProjectItems;
        this.syncRelatedProjectStatuses();
        this.updateProjectsScrollable();
      });
  }

  onProjectAdded(): void {
    this.loadRelatedProjects();
  }

  relatedProjectsSearchTerm: string = '';

  get filteredRelatedProjects(): any[] {
    if (!this.relatedProjects) return [];
    const term = (this.relatedProjectsSearchTerm || '').trim().toLowerCase();
    if (!term) return this.relatedProjects;
    return this.relatedProjects.filter((item: any) =>
      (item.project?.projectName || '').toLowerCase().includes(term)
    );
  }

  // Derived source routing (task, cost, property, component) to show as pills.
  // Excludes the internal "manual" marker — the manual link is represented by its own
  // removable role pill instead (data.role / removeManualProjectRole).
  sourceRouting(data: any): any[] {
    return (data?.routingInfo ?? []).filter((r: any) => r.descriptionRouteType !== 'manual');
  }

  // Staged role pending confirmation in the delete-role popup below.
  deleteRoleVisible = false;
  deleteRoleMessage = '';
  private roleToRemove: any = null;

  removeManualProjectRole(item: any): void {
    if (!item?.projectContactId) {
      return;
    }
    this.roleToRemove = item;
    this.deleteRoleMessage = $localize`:@@deleteRoleConfirm:Are you sure you want to remove the role ${
      '<b>' + (item.role ?? '') + '</b>'
    }:role: from ${'<b>' + (item.project?.projectName ?? '') + '</b>'}:project:?`;
    this.deleteRoleVisible = true;
  }

  onDeleteRoleConfirmed(): void {
    const item = this.roleToRemove;
    this.deleteRoleVisible = false;
    this.roleToRemove = null;
    if (!item?.projectContactId) {
      return;
    }
    this.contactService
      .removeProjectContact({ ProjectContactId: item.projectContactId })
      .then((result: any) => {
        if (result?.hasError === true) {
          AppGlobals.ShowErrorMessage(result.feedback);
        } else {
          this.loadRelatedProjects();
        }
      })
      .catch((error: any) => AppGlobals.ShowErrorMessage(error));
  }

  onDeleteRoleAborted(): void {
    this.deleteRoleVisible = false;
    this.roleToRemove = null;
  }

  goTo(link) {
    this.router.navigate([link]);
  }

  saveChanges() {
    console.clear();

    const validation = this.companyValidationGroup.instance.validate();
    if (!validation.isValid) {
      this.validationToast.showToast($localize`Please fill in all fields before saving`);
      return;
    }

    let peopleRoles = [];
    this.companyPersons.forEach((person: any) => {
      peopleRoles.push({
        id: person.id,
        role: person.role,
      });
    });

    this.company.peopleRoles = peopleRoles;

    this.hasChanges = false;
    this.isSavingChanges = true;

    this.contactService
      .writeCompanyDetails({ CompanyItemModel: this.company })
      .then((result) => {
        if (result.hasError === true) {
          this.isSavingChanges = false;
          AppGlobals.ShowErrorMessage(result.feedback);
        } else {
          this.router.navigate(['contacts/companies']);
        }
      });
  }

  checkHasChanges(): void {
    if (!this.initialCompany) {
      this.hasChanges = false;
      return;
    }
    this.hasChanges = JSON.stringify(this.company) !== JSON.stringify(this.initialCompany);
  }

  saveUnsavedChanges(): Observable<boolean> {
    this.saveChanges();
    return of(false);
  }

  showPersonPopup(e) {
    this.contactService.getPersons({}).then(
      (result) => {
        if (result.hasError === true)
          AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.persons = result.personItems;
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
    this.personPopupVisible = true;
  }

  removePersonConfirmVisible = false;
  removePersonConfirmMessage = '';
  private personToRemove: any = null;

  confirmRemovePersonFromCompany(person: any): void {
    this.personToRemove = person;
    this.removePersonConfirmMessage = $localize`:@@removePersonConfirm:Are you sure you want to remove ${
      '<b>' + (person.firstname ?? '') + ' ' + (person.lastname ?? '') + '</b>'
    }:person: from this company?`;
    this.removePersonConfirmVisible = true;
  }

  onRemovePersonConfirmed(): void {
    const person = this.personToRemove;
    this.removePersonConfirmVisible = false;
    this.personToRemove = null;
    if (!person) {
      return;
    }
    this.removePersonFromCompany(person);
  }

  onRemovePersonAborted(): void {
    this.removePersonConfirmVisible = false;
    this.personToRemove = null;
  }

  private removePersonFromCompany(person: any) {
    let companyId = this.currentCompanyId;
    let personId = person.id;
    let removedItem = this.companyPersons.findIndex(
      (item) => item.id == personId
    );
    this.companyPersons.splice(removedItem, 1);
    this.contactService
      .removePersonFromCompany({
        CompanyPersonShareItem: { CompanyId: companyId, PersonId: personId },
      })
      .then((result) => { });
  }

  onPersonSelected(e) {
    let companyId = this.currentCompanyId;
    let personId = e.data.id;
    this.contactService
      .writeCompanyPersonShare({
        CompanyPersonShareItem: { CompanyId: companyId, PersonId: personId },
      })
      .then(
        (result) => {
          if (result.hasError === true)
            AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.saveToast({ type: true, feedback: $localize`:@@saved:Saved` });
            this.contactService
              .getCompanyDetails({ CompanyId: this.currentCompanyId })
              .then(
                (result) => {
                  if (result.hasError === true)
                    AppGlobals.ShowErrorMessage(result.feedback);
                  else {
                    this.companyPersons = result.companyDetailItem.persons;
                    this.personPopupVisible = false;
                  }
                },
                (error: any) => {
                  AppGlobals.ShowErrorMessage(error);
                }
              );
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
  }

  saveToast(e: any): void {
    const type = e.type ? "success" : "error";
    if ((this.type = "success")) {
      this.message = e.feedback;
    } else {
      AppGlobals.ShowErrorMessage(
        $localize`:@@errorTryAgain:ERROR: There was an error, please try again.`
      );
    }
    this.type = type;
    this.toastVisible = true;
  }

  addNewPerson(e) {
    this.personEditMode = true;
  }

  resetPopup(e) {
    this.personEditMode = false;
    if (this.popupPersonGrid) {
      this.popupPersonGrid.instance.searchByText('');
    }
  }

  getTag(item) {
    return this.contactTags.find((tag) => tag.id == item).title;
  }

  // The "x" on a pill removes just that tag — the dropdown below stays in sync since
  // both render from the same company.tags array.
  removeTag(item: any): void {
    this.company.tags = (this.company.tags ?? []).filter((t: any) => t != item);
  }

  setEditMode(arg) {
    if (arg === true) {
      this.companyCopy = structuredClone(this.company);
    }

    if (arg === false) {
      this.company = this.companyCopy;
    }

    this.editMode = arg;
  }

  deleteCompany(e) {
    this.deletePopupVisible = false;
    try {
      this.contactService
        .deleteCompany({ CompanyId: this.currentCompanyId })
        .then((result) => {
          if (result.isInUse === true) {
            custom({
              title: $localize`:@@deletionNotPossibleTitle:Deletion not possible`,
              messageHtml: $localize`:@@contactInUseErrorMessage:This contact is still linked to projects or contracts. Please remove these links first.`,
              buttons: [{ text: $localize`:@@confirm:Confirm`, onClick: () => true }],
            }).show();
          } else if (result.hasError === true) {
            AppGlobals.ShowErrorMessage(result.feedback);
          } else {
            this.router.navigate(["contacts/companies"]);
          }
        });
    } catch (error) {
      console.error("Error in deleteCompany: ", error);
    }
  }

  handleRoleBlur(item: any): void {
    item.data.editMode = false;
  }

  gotoContact(person: any): void {
    this.router.navigate(["./contacts/person/" + person.id]);
  }

  getCountriesByLanguage(): void {
    this.gridConnectionService.getCountries({}).then(
      (result) => {
        if (result.hasError === true)
          AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.countriesByLanguageList = result.countryList;
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  /*   getStatesByLanguage(countryID: any): void {
      let selectedCountry = { "CountryId": countryID, }
  
      this.gridConnectionService.getStates(selectedCountry).then((result) => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.statesByLanguageList = result.stateList;
        }
      },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        });
  
    } */

  handleCountryChange(e: any): void {
    /*     this.getStatesByLanguage(e); */
  }

  @HostListener("document:keydown", ["$event"])
  onKeydown(event: KeyboardEvent) {
    if (event.key === "Control" || event.key === "Meta") {
      this.isCtrlPressed = true;
    }
  }

  @HostListener("document:keyup", ["$event"])
  onKeyup(event: KeyboardEvent) {
    if (event.key === "Control" || event.key === "Meta") {
      this.isCtrlPressed = false;
    }
  }

  onCellClick(e: any) {
    if (e.columnIndex == 0) {
      if (e.data.projectType == "project") {
        if (!this.isCtrlPressed) {
          this.router.navigate([
            `site/${e.data.siteId}/project/${e.data.projectId}`,
          ]);
        } else {
          window.open(`site/${e.data.siteId}/project/${e.data.projectId}`);
        }
      }

      if (e.data.projectType == "grid") {
        if (!this.isCtrlPressed) {
          this.router.navigate([`site/${e.data.siteId}`]);
        } else {
          window.open(`site/${e.data.siteId}`);
        }
      }
    }
  }

  onItemClick(data, routeData: any) {
    switch (routeData.descriptionRouteType) {
      case "task":
        if (!this.isCtrlPressed) {
          this.router.navigate([
            `site/${data.siteId}/project/${data.projectId}/tasks/${routeData.descriptionRouteId}`,
          ]);
        } else {
          window.open(
            `site/${data.siteId}/project/${data.projectId}/tasks/${routeData.descriptionRouteId}`
          );
        }
        break;

      case "property":
        if (!this.isCtrlPressed) {
          this.router.navigate([
            `site/${routeData.descriptionRouteId}/properties/`,
          ]);
        } else {
          window.open(`site/${routeData.descriptionRouteId}/properties/`);
        }
        break;

      case "gridComponent":
        if (!this.isCtrlPressed) {
          this.router.navigate([`site/${data.siteId}/infrastructure`]);
        } else {
          window.open(`site/${data.siteId}/infrastructure`);
        }
        break;

      case "projectComponent":
        if (!this.isCtrlPressed) {
          this.router.navigate([
            `site/${data.siteId}/project/${data.projectId}/projectInfo/components`,
          ]);
        } else {
          window.open(
            `site/${data.siteId}/project/${data.projectId}/projectInfo/components`
          );
        }
        break;

      case "project-cost":
        if (!this.isCtrlPressed) {
          this.router.navigate([
            `site/${data.siteId}/project/${data.projectId}/project-costs`,
          ]);
        } else {
          window.open(
            `site/${data.siteId}/project/${data.projectId}/project-bacostskosten`
          );
        }
        break;
    }
  }

  relatedContractsSearchTerm: string = '';

  get filteredRelatedContracts(): any[] {
    if (!this.relatedContracts) return [];
    const term = (this.relatedContractsSearchTerm || '').trim().toLowerCase();
    if (!term) return this.relatedContracts;
    return this.relatedContracts.filter((item: any) =>
      (item.designation || '').toLowerCase().includes(term)
    );
  }

  onRelatedContractsRowClick($event: any) {
    this.contractService.setPreviousUrl(this.router.url);
    this.router.navigate([
      `contracts/edit/${$event.data.id}`,
    ]);
  }
}
